import React, { useState, useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
// import "./Testimonials.css";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1400 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 1400, min: 1024 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
  },
};

const Testimonials = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const testimonials = [
    {
      id: 1,
      name: "TechNova Solutions",
      role: "IoT Implementation Client",
      text: "The IoT solution developed by this team transformed our manufacturing process. Real-time monitoring and predictive maintenance have increased our efficiency by 40%.",
      service: "IoT Services",
      rating: 5,
    },
    {
      id: 2,
      name: "Global Retail Corp",
      role: "E-commerce Platform Client",
      text: "Our new e-commerce platform has increased conversions by 65%. The seamless user experience and robust backend have exceeded our expectations.",
      service: "Web Development",
      rating: 5,
    },
    {
      id: 3,
      name: "Smart City Initiative",
      role: "Municipal IoT Project",
      text: "The smart traffic management system has reduced congestion by 30%. Their IoT expertise and attention to detail made this complex project a success.",
      service: "IoT Services",
      rating: 4,
    },
    {
      id: 4,
      name: "HealthTech Innovations",
      role: "Healthcare Platform Client",
      text: "Our patient portal has revolutionized how we deliver care. The team's understanding of both technology and healthcare needs was impressive.",
      service: "Web Development",
      rating: 5,
    },
    {
      id: 5,
      name: "AgriTech Solutions",
      role: "Smart Farming Client",
      text: "The IoT sensors for soil monitoring and automated irrigation have increased our crop yield by 25% while reducing water usage.",
      service: "IoT Services",
      rating: 5,
    },
    {
      id: 6,
      name: "FinTech Global",
      role: "Banking Platform Client",
      text: "The secure, responsive banking platform handles millions of transactions daily without issues. Their development expertise is exceptional.",
      service: "Web Development",
      rating: 5,
    },
  ];

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <span key={i} className={i < rating ? "star filled" : "star"}></span>
    ));
  };

  const getServiceIcon = (service) => {
    if (service === "IoT Services") {
      return (
        <div className="service-icon iot-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"/>
            <circle cx="5" cy="12" r="2"/>
            <circle cx="19" cy="4" r="2"/>
            <circle cx="19" cy="20" r="2"/>
            <path d="M12 3h2v2h-2zM12 19h2v2h-2zM3 12h2v2H3zM19 12h2v2h-2z"/>
          </svg>
        </div>
      );
    } else {
      return (
        <div className="service-icon web-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
          </svg>
        </div>
      );
    }
  };

  return (
    <div className={`testimonials-modern ${isVisible ? "visible" : ""}`}>
      <div className="testimonials-container">
        <div className="testimonials-header">
          <div className="title-section">
            <div className="subtitle">Client Success Stories</div>
            <h2>What Our Clients Say</h2>
            <div className="title-decoration"></div>
          </div>
          <div className="description-section">
            <p>
              Discover how our IoT and Web Development solutions have transformed 
              businesses across industries. From smart automation to cutting-edge 
              web platforms, our clients achieve remarkable results.
            </p>
          </div>
        </div>

        <Carousel
          responsive={responsive}
          arrows={false}
          showDots={true}
          autoPlay={true}
          autoPlaySpeed={4000}
          infinite={true}
          keyBoardControl={true}
          customTransition="transform 600ms ease-in-out"
          transitionDuration={600}
          containerClass="testimonial-carousel"
          itemClass="testimonial-item"
          removeArrowOnDeviceType={["mobile"]}
        >
          {testimonials.map((testimonial, index) => (
            <div className="testimonial-card" key={testimonial.id}>
              <div className="testimonial-content">
                <div className="card-header">
                  {getServiceIcon(testimonial.service)}
                  <div className="service-badge">{testimonial.service}</div>
                </div>
                
                <div className="quote-icon">"</div>
                
                <div className="testimonial-text">
                  {testimonial.text}
                </div>
                
                <div className="rating">
                  {renderStars(testimonial.rating)}
                </div>
                
                <div className="testimonial-author">
                  <div className="author-avatar">
                    <div className="avatar-placeholder">
                      {testimonial.name.charAt(0)}
                    </div>
                  </div>
                  <div className="author-info">
                    <h4>{testimonial.name}</h4>
                    <p>{testimonial.role}</p>
                  </div>
                </div>
              </div>
              
              <div className="card-background"></div>
            </div>
          ))}
        </Carousel>
        
        <div className="testimonials-cta">
          <p>Ready to transform your business with our solutions?</p>
          <button className="cta-button">Start Your Project</button>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;